import React from 'react';
import useSWR from 'swr';
import localforage from 'localforage';
import { loadCompanyUsers } from '../Services';

const loadFromLocalForage = async key => {
    return await localforage.getItem(key);
};

const saveToLocalForage = async (key, data) => {
    await localforage.setItem(key, data);
};

export const withUsers = Component => {
    return function WrappedComponent(props) {
        const { app } = props;
        const { currentUser } = app;
        const usersUrl = `/api/organization/${props.company.id}/users`;
        const usersKey = currentUser.uuid + '-' + usersUrl;
        const { data, error, isLoading, isValidating, mutate } = useSWR(
            usersKey,
            () => loadCompanyUsers(props.company.id),
            {
                onLoadingSlow: async () => {
                    const cachedData = await loadFromLocalForage(usersKey);

                    if (cachedData) {
                        mutate(cachedData, false);
                    }
                },
                loadingTimeout: 2500,
                onSuccess: async data => {
                    await saveToLocalForage(usersKey, data);
                },
                revalidateOnMount: true,
                revalidateIfStale: false,
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
            }
        );
        return (
            <Component
                {...props}
                data={data}
                error={error}
                isLoading={typeof data !== 'undefined' ? false : isLoading}
                isValidating={isValidating}
            />
        );
    };
};
